import { createFileRoute } from '@tanstack/react-router';

import { getContactDataOptions } from 'hooks/data/useContactData';

import { ContactView } from 'views/ContactView';
import { ErrorComponent } from 'views/ContactView/ErrorComponent';

export const Route = createFileRoute('/_auth/_layout/contact/$id')({
  component: ContactView,
  staticData: {
    disablePointBar: true,
  },
  loader: ({ context: { queryClient }, params }) => {
    return queryClient.ensureQueryData(getContactDataOptions(params));
  },
  errorComponent: ErrorComponent,
});
